var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137.5,
    cy: 137.5,
    r: 137.5,
    fill: "#3B3D4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.779 203.795C86.3138 203.795 84.9086 203.213 83.8726 202.177C82.8365 201.141 82.2545 199.735 82.2545 198.27V76.73C82.2546 75.77 82.5049 74.8266 82.9808 73.9928C83.4566 73.159 84.1414 72.4636 84.9679 71.9751C85.7943 71.4866 86.7337 71.2219 87.6936 71.2071C88.6535 71.1922 89.6007 71.4278 90.4418 71.8905L200.933 132.661C201.799 133.138 202.521 133.838 203.024 134.689C203.528 135.541 203.793 136.511 203.793 137.5C203.793 138.489 203.528 139.46 203.024 140.311C202.521 141.162 201.799 141.863 200.933 142.34L90.4418 203.11C89.6261 203.559 88.7102 203.794 87.779 203.795Z",
    fill: "#BEDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a4a27c99520a2f92bfe3c879ae1800d5.svg";
export { ForwardRef as ReactComponent };